import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updateUserSelf } from "../api";

export const useUpdateUserMe = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: updateUserSelf,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["user-me"] });
      router("/profile");
      toast.success("Success Update");
    },
  });

  return { update: mutate, isPending };
};
